// 报告相关接口
import request from './request'

/**
 * 获取报告首页数据
 * @param {Object} params - 请求参数
 * @param {string} params.userId - 用户 ID
 * @returns {Promise}
 */
export function getReportHome(params) {
  return request({
    url: '/api/report/home',
    method: 'post',
    data: params
  })
}

